import { c as _c } from "react/compiler-runtime";
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading/H4';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import type { ReactNode } from 'react';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
type GoalPath = {
  title: ReactNode;
  leadsTo: ReactNode;
};
const GOAL_PATHS: GoalPath[] = [{
  title: 'Podstawy programowania',
  leadsTo: <>
        Ścieżka dla ambitnych uczniów, którzy jeszcze nie zaczęli przygody z{'\u00A0'}programowaniem{' '}
        <span className='whitespace-nowrap'>- od{'\u00A0'}pierwszych</span> linii kodu po solidne
        fundamenty pod dalszy rozwój
      </>
}, {
  title: 'Olimpiada Informatyczna Juniorów',
  leadsTo: <>
        Trening pod OIJ dla uczniów szkół podstawowych{' '}
        <span className='whitespace-nowrap'>- od</span> podstaw algorytmiki po zadania w{'\u00A0'}
        stylu olimpijskim i{'\u00A0'}systematyczne przygotowanie do kolejnych etapów
      </>
}, {
  title: 'Olimpiada Informatyczna',
  leadsTo: <>
        Trening pod ogólnopolskie zawody dla licealistów. Zadania w{'\u00A0'}stylu olimpijskim,
        podejście do kolejnych etapów i{'\u00A0'}umiejętności, które odróżniają finalistów
      </>
}, {
  title: <>Rozmowy rekrutacyjne w{'\u00A0'}IT</>,
  leadsTo: <>
        Przygotowanie do rozmów o{'\u00A0'}pracę w{'\u00A0'}firmach technologicznych{' '}
        <span className='whitespace-nowrap'>- zadania</span> algorytmiczne, wiedza techniczna i
        {'\u00A0'}umiejętności miękkie, które wyróżnią Cię podczas rozmowy z{'\u00A0'}rekruterem
      </>
}, {
  title: 'Praktyczne AI',
  leadsTo: <>
        Wprowadzenie do sztucznej inteligencji w{'\u00A0'}nauce i{'\u00A0'}pracy{' '}
        <span className='whitespace-nowrap'>- dobór</span> właściwych narzędzi, skuteczna praca z
        {'\u00A0'}nimi i{'\u00A0'}granice, o{'\u00A0'}których warto wiedzieć
      </>
}, {
  title: 'Rekrutacja na studia',
  leadsTo: <>
        Przygotowanie do rekrutacji na{'\u00A0'}informatykę i{'\u00A0'}kierunki ścisłe{' '}
        <span className='whitespace-nowrap'>- matura</span> z{'\u00A0'}matematyki lub informatyki,
        egzaminy wstępne i{'\u00A0'}budowanie mocnego profilu kandydata
      </>
}];
export function GroupMentoringGoalPaths() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VerticalSpacer size="content" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4 id="goal-paths-heading" className="text-contentPrimary">Do czego Cię przygotowujemy</H4>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="whitespace-nowrap">- olimpiada,</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-1">{t1}<P2 className="text-contentSecondary">Na początku ustalamy razem, do czego zmierzasz{" "}{t2} studia, praca, wykorzystanie AI{" "}<span className="whitespace-nowrap">- i{"\xA0"}dobieramy</span> materiał pod ten cel. Aktualnie w{"\xA0"}ramach mentoringu podstawowego wspieramy następujące ścieżki:</P2></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section aria-labelledby="goal-paths-heading" className="space-y-4">{t0}{t3}<ul className="space-y-4">{GOAL_PATHS.map(_temp)}</ul></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(path, index) {
  return <li key={typeof path.title === "string" ? path.title : index}><IconOnTheLeftWithContentLayout mainContent={<P2 className="text-contentSecondary"><strong className="block font-semibold text-contentPrimary">{path.title}</strong>{path.leadsTo}</P2>} /></li>;
}